import type { Translations } from '../../../types'

const profileToastMessages: Translations = {
  "profile.toast.loadError": "Impossibile caricare il profilo.",
  "profile.toast.loginRequired": "Fai login per aggiornare il profilo.",
  "profile.toast.updateError": "Impossibile aggiornare il profilo.",
  "profile.toast.updated": "Profilo aggiornato.",
  "profile.toast.passwordError": "Impossibile aggiornare la password.",
  "profile.toast.passwordUpdated": "Password aggiornata.",
}

export default profileToastMessages
